module.exports = __webpack_public_path__ + "img/NVC-alt.070706c1.svg";